import { useEffect, useMemo, useCallback } from 'react'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

import ReactPaginate from 'react-paginate'
import { useMain } from '../../contexts/MainContext'

import api from '../../services/api'

import { Header } from '../../components/Header'
import { ModalAdd } from '../../components/ModalAdd'
import { ModalEdit } from '../../components/ModalEdit'
import { ModalDelete } from '../../components/ModalDelete'
import { Botao } from '../../components/Botao'

import Edit from '../../assets/edit.svg'
import Checked from '../../assets/checked.svg'
import Unchecked from '../../assets/unchecked.svg'
import Trash from '../../assets/trash.svg'

import { Container, Title, Table } from './styles'

export function ClubeDoParqueContent() {
 const title = 'Clube do Parque'
 const subtitle = 'Conteúdo da página'

 const fields = useMemo(
  () => [
   {
    id: 'Conteúdo Clube do Parque',
    title: String,
    text: String,
    status: Number
   }
  ],
  []
 )

 const {
  clubeDoParque,
  setClubeDoParque,
  modalAdd,
  toggleModalAdd,
  modalEdit,
  toggleModalEdit,
  modalDelete,
  toggleModalDelete,
  id,
  setID,
  offset,
  limit,
  handlePageClick
 } = useMain()

 const pageCount = Math.ceil(clubeDoParque.length / limit)

 const loadContent = useCallback(async () => {
  try {
   const response = await api.get('clubedoparque-content')

   setClubeDoParque(response.data)
  } catch (error) {
   console.log('Ocorreu um erro ao buscar o conteúdo.')
  }
 }, [setClubeDoParque])

 useEffect(() => {
  loadContent()
 }, [loadContent])

 return (
  <>
   <ToastContainer />

   {modalAdd && (
    <ModalAdd
     isClose={toggleModalAdd}
     isLoad={loadContent}
     fields={fields}
     name="clubedoparque-content"
     title="Conteúdo da página - Clube do parque"
    />
   )}
   {modalDelete && (
    <ModalDelete
     isClose={toggleModalDelete}
     isLoad={loadContent}
     id={id}
     name="clubedoparque-content"
     title="Conteúdo da página - Clube do parque"
    />
   )}
   {modalEdit && (
    <ModalEdit
     isClose={toggleModalEdit}
     isLoad={loadContent}
     id={id}
     name="clubedoparque-content"
     title="Conteúdo da página - Clube do parque"
    />
   )}

   <Header title={title} subtitle={subtitle} />

   <Container>
    <Title>Gerenciador de conteúdo</Title>
    {clubeDoParque.length <= 0 ? (
     <>Nenhum conteúdo cadastrado.</>
    ) : (
     <>
      <Table>
       <thead>
        <tr>
         <th>Exibição</th>
         <th>Título</th>
         <th>Texto do serviço</th>
         <th>Status</th>
         <th colSpan="2"></th>
        </tr>
       </thead>
       <tbody>
        {clubeDoParque &&
         clubeDoParque.slice(offset, offset + limit).map(content => (
          <tr key={content.id}>
           <td>{content.id}</td>
           <td>{content.title}</td>
           <td>{content.text.replace(/<[^>]*>/g, '')}</td>
           <td>
            {content.status === 1 ? (
             <img src={Checked} alt="Ativo" />
            ) : (
             <img src={Unchecked} alt="Inativo" />
            )}
           </td>
           <td onMouseDown={() => setID(content.id)}>
            <img
             src={Edit}
             alt="Editar"
             title="Editar"
             onClick={toggleModalEdit}
            />
           </td>
           <td onMouseDown={() => setID(content.id)}>
            <img
             src={Trash}
             alt="Deletar"
             title="Deletar"
             onClick={toggleModalDelete}
            />
           </td>
          </tr>
         ))}
       </tbody>
      </Table>

      <ReactPaginate
       previousLabel={'<'}
       nextLabel={'>'}
       pageCount={pageCount}
       onPageChange={handlePageClick}
       containerClassName={'pagination'}
       previousLinkClassName={'pagination__link'}
       nextLinkClassName={'pagination__link'}
       disabledClassName={'pagination__link--disabled'}
       activeClassName={'pagination__link--active'}
      />
     </>
    )}
   </Container>

   <Botao isOpen={toggleModalAdd} />
  </>
 )
}
